var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClock = function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.313 11.017.702-.702-2.518-2.518V4.666h-1v3.536zm-2.314 3.316q-1.315 0-2.47-.499a6.4 6.4 0 0 1-2.012-1.354 6.4 6.4 0 0 1-1.354-2.01A6.2 6.2 0 0 1 1.664 8q0-1.313.499-2.47A6.4 6.4 0 0 1 3.516 3.52a6.4 6.4 0 0 1 2.01-1.354 6.2 6.2 0 0 1 2.47-.499q1.314 0 2.47.499 1.157.498 2.012 1.353t1.354 2.01q.499 1.156.499 2.47t-.499 2.47a6.4 6.4 0 0 1-1.353 2.012 6.4 6.4 0 0 1-2.01 1.354 6.2 6.2 0 0 1-2.47.499m-.002-1q2.217 0 3.775-1.559 1.56-1.558 1.559-3.775 0-2.216-1.559-3.775T7.997 2.666 4.222 4.224Q2.665 5.784 2.664 8q0 2.217 1.558 3.775 1.56 1.56 3.775 1.559"
  })));
};
export default SvgClock;